import React, { useState } from "react";
import { Button } from "react-bootstrap"; // Import Button from react-bootstrap

const EmailInputBox = () => {
  const [emailList, setEmailList] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      const newEmail = inputValue.trim();
      if (validateEmail(newEmail) && !emailList.includes(newEmail)) {
        setEmailList([...emailList, newEmail]);
      }
      setInputValue("");
      e.preventDefault();
    }
  };

  const validateEmail = (email) => {
    // Simple regex for basic email validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleRemoveEmail = (email) => {
    setEmailList((prevList) => prevList.filter((item) => item !== email));
  };

  const handleSendEmail = () => {
    // Add your send email logic here
    console.log("Sending emails:", emailList);
    setEmailList([]); // Clear the list after sending, if needed
    
  };

  return (
    <div className="email-input-container">
      <div className="email-input-box d-flex align-items-center">
        <div className="email-tags d-flex flex-wrap gap-2">
          {emailList.map((email, index) => (
            <div
              key={index}
              className="email-tag d-flex align-items-center bg-light p-1 rounded-3"
            >
              {email}
              <button
                type="button"
                onClick={() => handleRemoveEmail(email)}
                className="btn text-danger border-0 p-0 ms-2"
              >
                &times;
              </button>
            </div>
          ))}
        </div>
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleInputKeyDown}
          className=" email-input-field"
          placeholder="Enter email address"
        />
        <span className="text-dark f-14 help-text"><i class="fa-solid fa-circle-info"></i> Add emails, press Enter.</span>
        {/* <Button variant="dark" onClick={handleSendEmail}>
          Send
        </Button> */}
      </div>
      
      <style jsx>
        {`
          .email-input-container {
            width: 100%;
            max-width: 600px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
          }

          .email-input-box {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            border: 1px solid #ddd;
            border-radius: 4px;
            padding: 5px;
            background-color: #fff;
            min-height: 40px; /* Adjust height as needed */
          }

          .email-tags {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
          }

          .email-tag {
            display: flex;
            align-items: center;
            background-color: #e9ecef;
            margin-right: 5px;
            padding: 2px 6px;
            border-radius: 3px;
          }

          .email-input-field {
            flex: 1;
            border: none;
            outline: none;
            padding: 2px 6px;
            margin-left: 5px;
            position:relative;
          }
            .help-text{
            position:absolute;
            bottom:50px;
            left:18px;
            font-size:11px;
            }

          .email-input-field::placeholder {
            color: #aaa;
          }

          .btn {
            margin-left: 10px;
          }
        `}
      </style>
    </div>
    
  );
};

export default EmailInputBox;
